import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import InvestmentModel from '../models/InvestmentModel';

interface InvestmentSearchState {
    searchResults: InvestmentModel[],
    InvestmentSearchKeyword: string,
    triggerSearch: number,
    selectedInvestments: InvestmentModel[],
    datatableSelectedIndex: number,
    searchResultTotalRecord: number,
    triggerFocusCompanyName: number
    checkedInvestments: InvestmentModel[],
}

const initialState: InvestmentSearchState = {
    searchResults: [],
    InvestmentSearchKeyword: "",
    selectedInvestments: [],
    triggerSearch: 0,
    datatableSelectedIndex: -1,
    searchResultTotalRecord: 0,
    triggerFocusCompanyName: 0,
    checkedInvestments: []
}

export const InvestmentSearchSlice = createSlice({
    name: "InvestmentSearch",
    initialState,
    reducers: {
        setInvestmentSearchResults: (state, action: PayloadAction<InvestmentModel[]>) => {
            state.searchResults = action.payload;
        },
        setTriggerInvestmentSearch: (state, action: PayloadAction<number>) => {
            state.triggerSearch = action.payload;
        },
        setInvestmentSearchKeyword: (state, action: PayloadAction<string>) => {
            state.InvestmentSearchKeyword = action.payload;
        },
        setDatatableSelectedInvestmentIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setSearchResultTotalRecord: (state, action: PayloadAction<number>) => {
            state.searchResultTotalRecord = action.payload;
        },
        setSelectedInvestments: (state, action: PayloadAction<InvestmentModel[]>) => {
            state.selectedInvestments = action.payload;
        },
        setTriggerFocusCompanyName: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyName = action.payload;
        },
        setCheckedInvestments: (state, action: PayloadAction<InvestmentModel[]>) => {
            state.checkedInvestments = action.payload;
        },
    }
});

export const InvestmentSearchSelector = createSelector(
    (state: RootState) => state.investmentSearch,
    (data) => data
);

export const {
    setInvestmentSearchKeyword,
    setInvestmentSearchResults,
    setTriggerInvestmentSearch,
    setDatatableSelectedInvestmentIndex,
    setSearchResultTotalRecord,
    setSelectedInvestments,
    setTriggerFocusCompanyName,
    setCheckedInvestments
} = InvestmentSearchSlice.actions;

export default InvestmentSearchSlice.reducer;